import { useCallback, useMemo } from 'react';
import ApiClient from '../utils/apiClient';
import { useToast } from '../contexts/ToastContext';

export const useApiClient = () => {
    const { showError } = useToast();
    const apiClient = useMemo(() => ApiClient.getInstance(), []);

    const handleApiError = useCallback(async (response: Response) => {
        if (!response.ok) {
            try {
                const errorData = await response.json();
                const errorMessage = errorData.error || `HTTP ${response.status}: ${response.statusText}`;
                showError(errorMessage, errorData);
            } catch {
                showError(`HTTP ${response.status}: ${response.statusText}`);
            }
        }
        return response;
    }, [showError]);

    return useMemo(() => ({
        get: async (endpoint: string) => {
            const response = await apiClient.get(endpoint);
            return handleApiError(response);
        },
        post: async (endpoint: string, data?: any) => {
            const response = await apiClient.post(endpoint, data);
            return handleApiError(response);
        },
        put: async (endpoint: string, data?: any) => {
            const response = await apiClient.put(endpoint, data);
            return handleApiError(response);
        },
        delete: async (endpoint: string) => {
            const response = await apiClient.delete(endpoint);
            return handleApiError(response);
        }
    }), [apiClient, handleApiError]);
};